import { render } from "./HeaderInfo.vue?vue&type=template&id=35790dcf&scoped=true"
import script from "./HeaderInfo.vue?vue&type=script&lang=js"
export * from "./HeaderInfo.vue?vue&type=script&lang=js"

import "./HeaderInfo.vue?vue&type=style&index=0&id=35790dcf&scoped=true&lang=css"

import exportComponent from "E:\\workspace\\digital-gate\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35790dcf"]])

export default __exports__